// @flow

import { postToIframe } from 'dibs-xdomain-poster';
import { getBuyerId } from 'dibs-cookie-jar';
import getter from 'dibs-object-getter';

import type { OnApprovalForm_item as ItemProp } from '../components/__generated__/OnApprovalForm_item.graphql';
import type { OnApprovalFormState } from '../components/OnApprovalForm';

type OnApprovalFormData = $PropertyType<OnApprovalFormState, 'formData'>;

type FormData = {|
    ...OnApprovalFormData,
    item: ItemProp,
|};

export function sendOnApprovalRequest(formData: FormData) {
    const itemGetter = getter(formData).at('item');
    return postToIframe('https://www.tfaforms.com/responses/processor', {
        /* eslint-disable camelcase */
        tfa_870: formData.date,
        tfa_871: formData.zipCode,
        tfa_872: formData.city,
        tfa_873: formData.state,
        tfa_874: formData.duration,
        tfa_875: formData.details,
        tfa_876: itemGetter.value('title'),
        tfa_877: itemGetter.value('dibsReference'),
        tfa_878: itemGetter.at('pricing').at('retailPrice').value('amount'),
        tfa_879: getBuyerId(document.cookie),
        tfa_880: itemGetter.at('seller').value('serviceId'),
        tfa_dbFormId: 4699500,
        tfa_dbResponseId: '',
        tfa_dbControl: '8c884013197093af5216c75c1aaf6587',
        tfa_dbTimeStarted: Date.now(),
        tfa_referrer: window.location.href,
        tfa_dbVersionId: 6,
        tfa_switchedoff: '',
        /* eslint-enable camelcase */
    });
}
